import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Friend } from '../../../../../../spartacus/custom/core/custom-friends/custom-friends-users/facade/friends.model';
import { User } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsCustomMyFriendsListComponent } from '../custom-my-friends-list/custom-my-friends-list.component';
import { Observable, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-custom-add-friend',
  templateUrl: './custom-my-account-friend-edit.component.html',
  styleUrls: ['./custom-my-account-friend-edit.component.scss'],
})
export class CustomMyAccountFriendEditFormComponent implements OnInit, OnDestroy {
  component = inject(CmsComponentData<CmsCustomMyFriendsListComponent>);
  protected subscription = new Subscription();
  isActive = false;
  friend: Friend;
  edit = false;
  user: User;
  email = false;
  content: string;
  data$: Observable<CmsCustomMyFriendsListComponent> = this.component.data$.pipe(
    tap((data) => {
      this.content = data.content;
    })
  );

  ngOnInit(): void {
    this.subscription.add(
      this.data$.subscribe(),
    );
  } 

  setActive(value: boolean): void {
    this.isActive = value;
  }

  setFriend(friend: Friend): void {
    this.friend = friend;
  }

  setEdit(value: boolean): void {
    this.edit = value;
  }

  setUser(value: User): void {
    this.user = value;
  }

  setEmail(value: boolean): void {
    this.email = value;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
